import { useAuth } from '../contexts/AuthContext';

export function PendingApprovalPage() {
  const { user, logout, refreshUser } = useAuth();

  const handleRefresh = async () => {
    await refreshUser();
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full p-8 bg-white rounded-lg shadow-md text-center">
        <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-yellow-100 flex items-center justify-center">
          <svg
            className="w-8 h-8 text-yellow-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>

        <h1 className="text-xl font-bold mb-2">等待審核</h1>

        <p className="text-gray-600 mb-4">
          您的帳號 <span className="font-medium">{user?.email}</span>{' '}
          正在等待管理員審核。
          <br />
          審核通過後即可開始使用。
        </p>

        <div className="flex flex-col gap-2">
          <button
            onClick={handleRefresh}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            檢查審核狀態
          </button>
          <button
            onClick={logout}
            className="text-gray-500 hover:text-gray-700 text-sm"
          >
            使用其他帳號登入
          </button>
        </div>
      </div>
    </div>
  );
}
